// Module
var code = "<div class=\"calendar-mini\"> <div class=\"calendar-month\"> <span ng-if=\"$ctrl.monthName\">{{$ctrl.monthName}}</span> <month ng-if=\"!$ctrl.monthName\" createdmonth=\"$ctrl.monthNumber\"></month> </div> <div class=\"calendar-day\">{{$ctrl.day}}</div> </div> ";
// Exports
module.exports = code;